import styles from "./ServiceType.module.css";
import React from "react";

function ServiceType({ selectedService = 1, onServiceChange }) {
  const serviceTypes = JSON.parse(sessionStorage.getItem("serviceTypes"));
  return (
    <select id="" name="serviceType" className={styles.select} onChange={onServiceChange} defaultValue={selectedService}>
      {serviceTypes.map((serviceType) => {
        return (
          <option
            value={serviceType.idServiceType}
            key={serviceType.idServiceType}
            //selected={selectedService == serviceType.idServiceType ? true : false}
          >
            {serviceType.Description}
          </option>
        );
      })}
    </select>
  );
}

export default ServiceType;
